"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.OrderedList = exports.inputRegex = void 0;
var core_1 = require("@tiptap/core");
var prosemirror_inputrules_1 = require("prosemirror-inputrules");
exports.inputRegex = /^(\d+)\.\s$/;
exports.OrderedList = core_1.Node.create({
    name: "orderedList",
    defaultOptions: {
        HTMLAttributes: {}
    },
    group: "block list",
    content: "listItem+",
    addAttributes: function () {
        return {
            start: {
                "default": 1,
            }
        };
    },
    parseHTML: function () {
        return [
            {
                tag: 'ol[start="1"]'
            }
        ];
    },
    renderHTML: function (_a) {
        var HTMLAttributes = _a.HTMLAttributes;
        var start = HTMLAttributes.start, attributesWithoutStart = __rest(HTMLAttributes, ["start"]);
        return ["ol", core_1.mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands: function () {
        return {
            toggleOrderedList: function () {
                return function (_a) {
                    var commands = _a.commands;
                    return commands.toggleList("orderedList", "listItem");
                };
            }
        };
    },
    addKeyboardShortcuts: function () {
        var _this = this;
        return {
            "Mod-Shift-7": function () { return _this.editor.commands.toggleOrderedList(); }
        };
    },
    addInputRules: function () {
        return [
            prosemirror_inputrules_1.wrappingInputRule(exports.inputRegex, this.type, function (match) { return ({ start: +match[1], type: "" }); }, function (match, node) { return node.childCount + node.attrs.start === +match[1]; })
        ];
    }
});
